import { programmeTypes } from '@constants/index';
import { PROGRAMME_COMPOSITION_ONLINE_OFFLINE } from '../CreatePlusCourse/constants';

const calculateSubconceptsCoveredPercentage = (
  coveredSubconcepts,
  totalSubconcepts
) => {
  const percentage = (coveredSubconcepts / totalSubconcepts) * 100;
  return Math.ceil(percentage);
};

export const getIsOfflineTestSeries = (programmeType) => {
  return programmeType === programmeTypes.HYBRID_TESTSERIES;
};

export const getIsCbtTestSeries = (programmeType) =>
  programmeType === programmeTypes.CBT_TEST_SERIES;

export const getIsCbtOfflineComposition = (
  programmeType,
  programmeComposition
) =>
  getIsCbtTestSeries(programmeType) &&
  programmeComposition === PROGRAMME_COMPOSITION_ONLINE_OFFLINE;

export default calculateSubconceptsCoveredPercentage;
